import { Home } from "../models/home";
import { WebSale } from "../models/webSale";
import { Whatsapp } from "../models/whatsapp";
import http from "../http/http-config";

export default new class WebSalesSettingService {
    getHomeSettings(urlSite: string): Promise<Home | null> {
        return http.get<Home>("WebSalesSettings/GetHomeSettings", {
            params: {
                urlSite
            }
        }).then(response => response.data);
    }

    getWebSalesSettings(urlSite: string, urlSiteVw: string): Promise<WebSale | null> {
        return http.get<WebSale>("WebSalesSettings/GetWebSalesSettings", {
            params: {
                urlSite,
                urlSiteVw
            }
        }).then(response => response.data);
    }

    checkWebSalesSettings(): Promise<string | null> {
        return http.get<string>("WebSalesSettings/CheckWebSalesSettings").then(response => response.data);
    }

    cleanWebSalesSettings(): Promise<string | null> {
        return http.get<string>("WebSalesSettings/CleanWebSalesSettings").then(response => response.data);
    }

    initializeWebSales(): Promise<string | null> {
        return http.get<string>("WebSalesSettings/InitializeWebSales").then(response => response.data);
    }

    getWhatsappSettings(): Promise<Whatsapp | null> {
        return http.get<Whatsapp>("WebSalesSettings/GetWhatsappSettings").then(response => response.data);
    }
}